import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p>{new Date().getFullYear()} - MHLoyche - Datatechnician with a speciality in programming</p>
    </footer>
  );
}